// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screen-loading-modal {
  position: fixed !important;
  inset: 0 !important;
  left: 0 !important;
  top: 0 !important;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  padding: clamp(24px, 5vh, 60px) var(--space-4, 16px) var(--space-8, 32px);
  background: rgba(244, 247, 247, 0.85);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  z-index: 1200;
  pointer-events: none;
}

[data-theme="dark"] .screen-loading-modal,
.dark .screen-loading-modal,
html[data-theme="dark"] .screen-loading-modal {
  background: rgba(20, 22, 26, 0.85);
}

.screen-loading-shell {
  width: min(100%, 1120px);
  display: flex;
  flex-direction: column;
  gap: var(--space-6, 24px);
  outline: none;
  pointer-events: auto;
}

.screen-reader-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/LoadingModel/Loading.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,yEAAyE;EACzE,qCAAqC;EACrC,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,oBAAoB;AACtB;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".screen-loading-modal {\n  position: fixed !important;\n  inset: 0 !important;\n  left: 0 !important;\n  top: 0 !important;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  overflow-y: auto;\n  padding: clamp(24px, 5vh, 60px) var(--space-4, 16px) var(--space-8, 32px);\n  background: rgba(244, 247, 247, 0.85);\n  backdrop-filter: blur(2px);\n  z-index: 1200;\n  pointer-events: none;\n}\n\n[data-theme=\"dark\"] .screen-loading-modal,\n.dark .screen-loading-modal,\nhtml[data-theme=\"dark\"] .screen-loading-modal {\n  background: rgba(20, 22, 26, 0.85);\n}\n\n.screen-loading-shell {\n  width: min(100%, 1120px);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6, 24px);\n  outline: none;\n  pointer-events: auto;\n}\n\n.screen-reader-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
